const DEFAULT_CLIENT = 'tuid';
const contextPath = process.env.REACT_APP_CONTEXT || '';

const BRANDINGS = {
    tuid: {
        id: 'tuid',
        themeClass: 'theme-tuid',
    },
    dnit: {
        id: 'dnit',
        themeClass: 'theme-dnit',
    },
    trident: {
        id: 'trident',
        themeClass: 'theme-trident',
    },
};

const normalizeClient = (clientName) => {
    const normalized = `${clientName || DEFAULT_CLIENT}`.trim().toLowerCase();
    return BRANDINGS[normalized] ? normalized : DEFAULT_CLIENT;
};

export const getBranding = (clientName = process.env.REACT_APP_CLIENT) => {
    const client = normalizeClient(clientName);
    return BRANDINGS[client];
};

export const getBrandThemeClass = (clientName = process.env.REACT_APP_CLIENT) =>
    getBranding(clientName).themeClass;

export const getBrandAsset = (format = 'svg', clientName = process.env.REACT_APP_CLIENT) => {
    const { id } = getBranding(clientName);
    return `${contextPath}/logos/${id}.${format}`;
};

export const getBrandLogoSvg = (clientName = process.env.REACT_APP_CLIENT) =>
    getBrandAsset('svg', clientName);

export const getBrandLogoPng = (clientName = process.env.REACT_APP_CLIENT) =>
    getBrandAsset('png', clientName);
